import React from "react";

import { Container, Row, Col } from "reactstrap";

import categoryImg01 from "../../../assets/images/ct-2.png";
import categoryImg02 from "../../../assets/images/ct-2.png";
import categoryImg03 from "../../../assets/images/ct-2.png";
import categoryImg04 from "../../../assets/images/ct-2.png";

import "../../../styles/category.css";

const categoryData = [
  {
    display: "I phone 13 max pro",
    imgUrl: categoryImg01,
  },
  {
    display: "I phone 12 max pro",
    imgUrl: categoryImg02,
  },

  {
    display: "I phone 15 max pro",
    imgUrl: categoryImg03,
  },

  {
    display: "Nathing phone 1",
    imgUrl: categoryImg04,
  },
];

const Category = () => {
  return (
    <Container>
      <Row>
        {categoryData.map((item, index) => (
          <Col lg="3" md="4" sm="6" xs="6" className="mb-4" key={index}>
            <div className="category__item d-flex align-items-center gap-3">
              <div className="category__img">
                <img   style={{width:'40px'}} src={item.imgUrl} alt="category__item" />
              </div>
              <h6>{item.display}</h6>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Category;
